import React, { Fragment } from "react"
import clsx from "clsx"

import { months } from "constant"
import { moment } from "utils"
import classes from "./ShiftCashierHistoryCard.module.scss"

const ShiftCashierHistoryCard = props => {
  const {
    shift,
    selectedShift,
    setSelectedShift
  } = props

  const isStartDateAndEndDateSame =
    !!shift.endAt &&
    (moment(shift.startAt).get("date") !== moment(shift.endAt).get("date"))

  return (
    <div
      onClick={() => setSelectedShift(shift)}
      className={
        clsx(classes["container"],
          selectedShift?._id === shift._id && classes["active"]
        )
      }
    >
      <b>
        {months[moment(shift.startAt).get("month")]}{" "}
        {moment(shift.startAt).format("jD")}

        {isStartDateAndEndDateSame
          ?
          <Fragment>
            {" "}-{" "}
            {months[moment(shift.endAt).get("month")]}{" "}
            {moment(shift.endAt).format("jD")}
          </Fragment>
          : ""
        }
      </b>

      <div className={classes["time"]}>
        {moment(shift.startAt).format("HH:mm")}

        {!!shift.endAt
          ?
          <Fragment>
            {" "}-{" "}
            {moment(shift.endAt).format("HH:mm")}
          </Fragment>
          :
          ""
        }
      </div>
    </div>
  )
}

export default ShiftCashierHistoryCard